import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import {
  Typography,
  Divider,
} from 'antd';
import { Link } from 'react-router-dom';

import moment from 'moment';
import {
  createColumns,
  formatCell,
  getURLParams,
  sorter,
} from '../../../helpers';

import { Filters } from '../../../containers/Filters';
import DataTable from '../../../containers/DataTable';
import {
  Spinner,
  TooltippedLink,
} from '../../UI';

const { Title } = Typography;

class SubID extends PureComponent {
  state = {
    filters: {
      dt1: '',
      dt2: '',
      aff: '',
      timeZone: '',
      count: 10,
    },
    today: moment(new Date()).format('YYYY-MM-DD'),
  };

  componentDidMount () {
    const params = getURLParams(window.location);
    const {
      dt1,
      aff,
    } = params;

    this.props.fetchUserInfo(() => {
      const payload = {
        dt1: dt1 ? dt1 : this.state.today,
        dt2: dt1 ? dt1 : this.state.today,
        aff: aff ? aff : '',
        timeZone: this.props.user.time_zone,
        count: this.state.filters.count
      };

      this.setState((state) => {
        return {
          filters: {
            ...state.filters,
            dt1: payload.dt1,
            dt2: payload.dt2,
            aff: payload.aff,
            timeZone: payload.timeZone,
          }
        };
      });

      this.props.fetchSubStats(payload);
    });
  };

  handleChange = (date, dateString) => {
    const [dt1, dt2] = dateString;

    this.setState((state) => {
      return {
        filters: {
          ...state.filters,
          dt1,
          dt2
        }
      };
    });

    const payload = {
      ...this.state.filters,
      dt1,
      dt2,
    };

    this.handleChangeFilter(payload);
  };

  handleSelect = (value) => {
    this.setState((state) => {
      return {
        filters: {
          ...state.filters,
          aff: value,
        }
      };
    });

    const payload = {
      ...this.state.filters,
      aff: value,
    };

    this.handleChangeFilter(payload);
  };

  handleChangeFilter = (payload) => {
    this.props.history.push({ search: '' });
    this.props.setFilter({
      ...this.props.filters,
      ...payload,
    });
    this.props.fetchSubStats(payload);
  };

  handleSub = (value) => {
    this.setState((state) => {
      return {
        filters: {
          ...state.filters,
          count: value,
        }
      };
    });

    const payload = {
      ...this.state.filters,
      count: value
    };

    this.props.fetchSubStats(payload);

    this.props.setFilter({
      ...this.props.filters,
      ...payload,
    });
  };

  update = () => {
    this.props.fetchSubStats(this.state.filters);
  };

  render() {
    const {
      pageLoading,
      loading,
      subStats,
      subStats: {
        fields,
        tableName,
      },
    } = this.props;
    const fieldsObj = fields && fields[0];
    const dateFormat = 'YYYY-MM-DD';
    const params = getURLParams(window.location);
    const dt1 = params.dt1 ? params.dt1 : '';

    const renderTableCell = (text, record, item) => {
      const { aff, saff, } = record;

      if (item.html) {
        if (item.html.id === 'ErrClicksStats') {
          const to = `/reports/filtered_clicks?dt1=${this.state.filters.dt1}&dt2=${this.state.filters.dt2}&aff=${aff}&saff=${saff}`;

          return item.html.tooltip ? (
            <TooltippedLink
              title={item.html.tooltip}
              link={formatCell(item, text)}
              to={to}
            />
          ) : (
            <Link to={to}>{formatCell(item, text)}</Link>
          );
        }
      }

      return formatCell(item, text);
    };

    const columns = createColumns(
      fieldsObj,
      sorter,
      renderTableCell,
    );

    let content = <Spinner />;
    if (!pageLoading) {
      content = (
        <>
          <Divider />
          <Filters
            defaultDate={[
              dt1 ? moment(dt1, dateFormat) : moment(),
              dt1 ? moment(dt1, dateFormat) : moment()
            ]}
            handleSelect={this.handleSelect}
            handleChange={this.handleChange}
            handleSub={this.handleSub}
            topsLabel="Top Sub IDs"
            subs={false}
          />
          <DataTable
            loading={loading}
            table={{
              columns: columns,
              data: subStats,
              tableName: tableName,
              toolbar: {
                titleExport: 'SubID Export',
              }
            }}
            update={this.update}
          />
        </>
      );
    }

    return (
      <div>
        <Title>Sub ID</Title>
        {content}
      </div>
    );
  }
}

SubID.propTypes = {
  pageLoading: PropTypes.bool.isRequired,
  loading: PropTypes.bool.isRequired,
  user: PropTypes.object.isRequired,
  subStats: PropTypes.object.isRequired,
  fetchUserInfo: PropTypes.func.isRequired,
  fetchSubStats: PropTypes.func.isRequired,
};

export default SubID;
